import { useMemo } from 'react';
import find from 'lodash.find';
import useGenreUrlParams from './useGenreUrlParams';
import { getParentFromGenre } from '@/helpers/pages/genres';
import useGenres, { GENRES_ALL_FLATTENED } from '@/react-query/genres/hooks/useGenres';

const useGenre = (queryParams) => {
  const { genreSlug } = useGenreUrlParams();

  const queryResults = useGenres({
    type: GENRES_ALL_FLATTENED,
    ...queryParams
  });
  const { genres: allGenresFlattened } = queryResults;
  const genre = useMemo(() => find(allGenresFlattened, ({ slug }) => slug === genreSlug), [allGenresFlattened, genreSlug]);
  const genreFormatted = useMemo(() => genre || {}, [genre]);
  const parentGenre = useMemo(() => getParentFromGenre(genreFormatted) || genreFormatted, [genreFormatted]);

  return {
    ...queryResults,
    genre: genreFormatted,
    parentGenre
  };
};

export default useGenre;